import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import NavProduct from '../comps/NavProduct';
import TabBundles from '../comps/TabBundles';
import TabRecycling from '../comps/TabRecycling';
import TabMedia from '../comps/TabMedia';
import TabSpecs from '../comps/TabSpecs';
import TabSupport from '../comps/TabSupport';
import { useProductDispatch, useProductStore } from '../ProductProvider';
import styles from './index.module.scss';
import ProductContent from './ProductContent';
import ShopifyShoppingCart from 'elem/compCommon/ShopifyShoppingCart';
import { ShopifyCartItemType } from 'elem/compCommon/ShopifyShoppingCart/const';
import ShopifyCartIcon from '@elem/compCommon/ShopifyCartIcon';
import { getSolarRecommand } from '@/service/solar-calculator';
import { createPortal } from 'react-dom';
import gtm from '@/utils/gtm';
import { langText } from 'elem/compPage/Delta3Series/detail/comps/P/EFCardCartLists/langText';
import { useLang } from '@/i18n';
import { EfCardCartItemProps } from './comps/P/EFCardCartLists';

const theme = 'white';
const tabList = ['Product', 'Recycling', 'Specs', 'Support', 'Media'];
export default function Detail() {
    const { productTabActive, pageStatus } = useProductStore();
    const dispatch = useProductDispatch();
    const router = useRouter();
    const { t } = useLang('delta3series');
    const { locale = 'us', query } = router;
    const tabName: string = (query.tab as string) || '';

    const [isClient, setIsClient] = useState(false);
    const [shoppingCarts, setShoppingCarts] = useState([]);
    const [visible, setVisible] = useState(false);
    const i18n = langText[locale] || langText.us;
    const IS_EU_SITES = ['eu', 'de', 'fr', 'it', 'es', 'ph'].includes(locale);
    const [showNav, setShowNav] = useState(!IS_EU_SITES || pageStatus !== 'statusA');

    const items: EfCardCartItemProps[] = [
        {
            tag: t('P_card1_tag'),
            title: t('P_card1_title'),
            desc: `${t('P_card1_power')}\n${t('P_card1_desc')}`,
            productId: '8095182717089',
            variantId: '44498903629985',
            quantity: 1,
        },
        {
            tag: t('P_card2_tag'),
            title: t('P_card2_title'),
            desc: `${t('P_card2_power')}\n${t('P_card2_desc')}`,
            productId: '14619593933167',
            variantId: '51641953550703',
            quantity: 1,
        },
        {
            tag: t('P_card3_tag'),
            title: t('P_card3_title'),
            desc: `${t('P_card3_power')}\n${t('P_card3_desc')}`,
            productId: '14686218781039',
            variantId: '51812607394159',
            quantity: 1,
        },
    ];
    const items2: EfCardCartItemProps[] = [
        {
            title: t('N_card1_title'),
            desc: '',
            productId: '8095160795297',
            variantId: '44597213003937',
            quantity: 1,
        },
        {
            title: t('N_card2_title'),
            desc: '',
            productId: '8095101517985',
            variantId: '51641953354095',
            quantity: 1,
        },
        {
            title: t('N_card3_title'),
            desc: '',
            productId: '14684998762863',
            variantId: '51809553744239',
            quantity: 1,
        },
    ];

    const delta3 = {
        img: 'https://websiteoss.ecoflow.com/upload/image/1723520858472/delta3_us_jp.png',
        title: t('P_card3_title'),
        desc: `${t('P_card3_power')}\n${t('P_card3_desc')}`,
        quantity: 1,
        btnCartText: '11月1日発売予定',
        inventory: 0,
    };

    const [cards, setCards] = useState(JSON.parse(JSON.stringify(items)));
    const [cards2, setCards2] = useState(JSON.parse(JSON.stringify(items2)));

    const getAsynItem = async (item: any) => {
        const { variantId, productId } = item;
        return await new Promise(async (resolve, reject) => {
            try {
                const res = await getSolarRecommand({ productId, variantId }, locale);
                if (res?.code === '0') {
                    item.discountPrice = res?.data?.price ?? undefined;
                    item.originalPrice = res?.data?.compareAtPrice ?? res?.data?.price ?? undefined;
                    item.inventory = res?.data?.inventoryQuantity ?? undefined;
                    item.img = res?.data?.img || 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717230567710/sg4000.png';
                    // item.inventory = 1;
                    item.link_buy = `https://${locale}.ecoflow.com/cart/${item.variantId}:1?channel=buy_button`;
                    if (res?.data?.productTitle || res?.data?.skuTitle) {
                        item.title = res?.data?.productTitle || res?.data?.skuTitle;
                    }
                    return resolve(res);
                } else {
                    console.error(res?.message);
                    return reject(res?.message);
                }
            } catch (e) {
                console.error(e);
                return reject(e);
            }
        });
    };

    const handleAddToCart = (card: any, list_name?: string) => {
        if (card?.inventory <= 0) {
            return;
        }
        const obj: ShopifyCartItemType = { ...card };
        const target = shoppingCarts.find((item: ShopifyCartItemType) => item?.productId === card?.productId && item?.variantId === card?.variantId);
        if (target) {
            obj.quantity = target.quantity + (target?.quantity < target.inventory ? 1 : 0);
            setShoppingCarts([
                obj,
                ...shoppingCarts?.filter((item: ShopifyCartItemType) => !(item?.productId === card?.productId && item?.variantId === card?.variantId)),
            ]);
        } else {
            obj.quantity = Number(obj?.inventory) > 0 ? 1 : 0;
            setShoppingCarts([obj, ...shoppingCarts]);
        }
        setVisible(true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'bundle_add_to_cart',
            product_name: card?.name || card?.title,
            list_name: list_name || 'none',
            price: card?.discountPrice,
            tag: 'none',
            quantity: 1,
            button_name: i18n.cart,
        });
    };

    const handleCallback = (carts: ShopifyCartItemType[], isClose?: boolean) => {
        setShoppingCarts(carts);
        const cards1Arr = JSON.parse(JSON.stringify(cards));
        const cards2Arr = JSON.parse(JSON.stringify(cards2));
        [...cards1Arr, ...cards2Arr].forEach((item: any) => {
            const target = carts.find((cart: ShopifyCartItemType) => cart?.variantId === item?.variantId);
            if (target) {
                item.quantity = target.quantity;
            }
        });
        setCards(cards1Arr);
        setCards2(cards2Arr);
        if (isClose) {
            setVisible(false);
        }
    };

    useEffect(() => {
        if (locale === 'jp') {
            const tempArr = JSON.parse(JSON.stringify(items));
            const tempArr2 = JSON.parse(JSON.stringify(items2));
            const promises = tempArr?.map((item: any) => getAsynItem(item));
            const promises2 = tempArr2?.map((item: any) => getAsynItem(item));
            Promise.all(promises)
                .then(() => {
                    setCards(tempArr);
                })
                .catch((e) => {
                    console.error(e);
                });
            Promise.all(promises2)
                .then(() => {
                    setCards2(tempArr2);
                })
                .catch((e) => {
                    console.error(e);
                });
        }
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    });

    useEffect(() => {
        if (tabName && tabList.includes(tabName)) {
            dispatch({
                type: 'changeProductTabActive',
                payload: tabName,
            });
        }
    }, [tabName]);

    useEffect(() => {
        setShowNav(locale === 'jp' || pageStatus !== 'statusA' || locale === 'au');
    }, [pageStatus]);
    return (
        <div className={styles.detail}>
            {showNav && <NavProduct />}
            <div className={`product-item-tab${productTabActive === 'Product' ? ' product-item-tab-active' : ''}`}>
                <ProductContent callbackCart={handleAddToCart} bundles={[...cards]} cards2={[...cards2]} />
            </div>
            {productTabActive === 'Bundles' && (
                <div className={`product-item-tab product-item-tab-active`}>
                    <TabBundles callbackCart={handleAddToCart} />
                </div>
            )}
            {productTabActive === 'Recycling' && (
                <div className={`product-item-tab product-item-tab-active`}>
                    <TabRecycling />
                </div>
            )}
            {productTabActive === 'Support' && (
                <div className={`product-item-tab product-item-tab-active`}>
                    <TabSupport theme={theme} />
                </div>
            )}
            {productTabActive === 'Specs' && (
                <div className={`product-item-tab product-item-tab-active`}>
                    <TabSpecs theme={theme} />
                </div>
            )}
            {productTabActive === 'Media' && (
                <div className={`product-item-tab product-item-tab-active`}>
                    <TabMedia />
                </div>
            )}
            {visible && isClient && createPortal(<ShopifyShoppingCart callback={handleCallback} items={shoppingCarts} />, document.body)}
            {isClient &&
                createPortal(
                    <ShopifyCartIcon
                        quantity={shoppingCarts.reduce((prev: number, curItem: ShopifyCartItemType) => {
                            return prev + Number(curItem.quantity);
                        }, 0)}
                        callback={() => setVisible(true)}
                    />,
                    document.body,
                )}
        </div>
    );
}
